export default __webpack_public_path__ + "static/media/photo18.8963c357.jpg";